// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TermLifeContent.css */
/* Style for regular text input boxes */
.custom-input {
  width: 100%; /* Set a fixed width for all text boxes */
  height: 40px; /* Set a fixed height for all text boxes */
  padding: 10px; /* Adjust the padding as needed */
  margin-bottom: 20px; /* Add spacing between text boxes */
  border: 1px solid #ccc; /* Add your desired border style */
  border-radius: 4px; /* Add your desired border radius */
  font-size: 16px; /* Adjust the font size as needed */
}

.labelStyle {
  margin-bottom: 20px;
}

/* Style for disabled text input boxes */
.disabled-input {
  width: 100%;
  height: 40px;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: #f4f4f4; /* Background color for disabled boxes */
}

.row-container {
  padding: 10px 0; /* Adjust the padding as needed */
}

.button-group {
  display: flex;
  gap: 10px;
}

/* Style for individual buttons (optional) */
.button-group button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

/* Style for individual buttons */
.action-button {
  width: 50px !important; /* Adjust the width as desired */
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.action-member-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.marginTop {
  margin-top: 20px !important;
}

/* Add this CSS to your stylesheet */
.green-border-input {
  border: 2px solid #56a080 !important; /* Green border color */
  background-position: right center !important; /* Position the tick mark on the right-center */
  background-size: 16px !important; /* Adjust the size as needed */
  padding-right: 20px !important; /* Add some padding for the tick mark */
  width: 100%; /* Set a fixed width for all text boxes */
  height: 40px; /* Set a fixed height for all text boxes */
  padding: 10px; /* Adjust the padding as needed */
  margin-bottom: 10px; /* Add spacing between text boxes */
  border-radius: 4px; /* Add your desired border radius */
  font-size: 16px; /* Adjust the font size as needed */
}
.red-border-input {
  border: 2px solid red !important; /* Green border color */
  background-position: right center !important; /* Position the tick mark on the right-center */
  background-size: 16px !important; /* Adjust the size as needed */
  padding-right: 20px !important; /* Add some padding for the tick mark */
  width: 100%; /* Set a fixed width for all text boxes */
  height: 40px; /* Set a fixed height for all text boxes */
  padding: 10px; /* Adjust the padding as needed */
  margin-bottom: 10px; /* Add spacing between text boxes */
  border-radius: 4px; /* Add your desired border radius */
  font-size: 16px; /* Adjust the font size as needed */
}

.action-limit-width {
  width: 20px !important; /* Adjust the width as desired */
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.insurance button {
  width: 50px !important;
}

/* TermLifeContent.css */

/* Style for the DataGrid header */
.data-grid .MuiDataGrid-colCellWrapper {
  background-color: transparent; /* Set the header background color to transparent */
  color: white; /* Set the header text color */
  border-bottom: none; /* Remove the bottom border from the header */
}

/* Style for the DataGrid rows */
.data-grid .MuiDataGrid-row {
  border-bottom: none; /* Remove the border below each row */
}

/* Style for the DataGrid selected rows */
.data-grid .Mui-selected {
  background-color: transparent; /* Set the background color for selected rows to transparent */
}

/* TermLifeContent.css */

.radio-group-label {
  margin-top: 12px !important; /* Adjust the top margin as needed */
  /* margin-left: 10px !important;  */
}

.long-text-input {
  width: 100%; /* Adjust the width as needed */
}

.validation-error {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/css/InsuranceContent.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB,uCAAuC;AACvC;EACE,WAAW,EAAE,yCAAyC;EACtD,YAAY,EAAE,0CAA0C;EACxD,aAAa,EAAE,iCAAiC;EAChD,mBAAmB,EAAE,mCAAmC;EACxD,sBAAsB,EAAE,kCAAkC;EAC1D,kBAAkB,EAAE,mCAAmC;EACvD,eAAe,EAAE,mCAAmC;AACtD;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA;EACE,eAAe,EAAE,iCAAiC;AACpD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,sBAAsB,EAAE,gCAAgC;EACxD,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,oCAAoC,EAAE,uBAAuB;EAC7D,4CAA4C,EAAE,+CAA+C;EAC7F,gCAAgC,EAAE,8BAA8B;EAChE,8BAA8B,EAAE,uCAAuC;EACvE,WAAW,EAAE,yCAAyC;EACtD,YAAY,EAAE,0CAA0C;EACxD,aAAa,EAAE,iCAAiC;EAChD,mBAAmB,EAAE,mCAAmC;EACxD,kBAAkB,EAAE,mCAAmC;EACvD,eAAe,EAAE,mCAAmC;AACtD;AACA;EACE,gCAAgC,EAAE,uBAAuB;EACzD,4CAA4C,EAAE,+CAA+C;EAC7F,gCAAgC,EAAE,8BAA8B;EAChE,8BAA8B,EAAE,uCAAuC;EACvE,WAAW,EAAE,yCAAyC;EACtD,YAAY,EAAE,0CAA0C;EACxD,aAAa,EAAE,iCAAiC;EAChD,mBAAmB,EAAE,mCAAmC;EACxD,kBAAkB,EAAE,mCAAmC;EACvD,eAAe,EAAE,mCAAmC;AACtD;;AAEA;EACE,sBAAsB,EAAE,gCAAgC;EACxD,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA,wBAAwB;;AAExB,kCAAkC;AAClC;EACE,6BAA6B,EAAE,mDAAmD;EAClF,YAAY,EAAE,8BAA8B;EAC5C,mBAAmB,EAAE,6CAA6C;AACpE;;AAEA,gCAAgC;AAChC;EACE,mBAAmB,EAAE,qCAAqC;AAC5D;;AAEA,yCAAyC;AACzC;EACE,6BAA6B,EAAE,8DAA8D;AAC/F;;AAEA,wBAAwB;;AAExB;EACE,2BAA2B,EAAE,oCAAoC;EACjE,mCAAmC;AACrC;;AAEA;EACE,WAAW,EAAE,+BAA+B;AAC9C;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* TermLifeContent.css */\r\n/* Style for regular text input boxes */\r\n.custom-input {\r\n  width: 100%; /* Set a fixed width for all text boxes */\r\n  height: 40px; /* Set a fixed height for all text boxes */\r\n  padding: 10px; /* Adjust the padding as needed */\r\n  margin-bottom: 20px; /* Add spacing between text boxes */\r\n  border: 1px solid #ccc; /* Add your desired border style */\r\n  border-radius: 4px; /* Add your desired border radius */\r\n  font-size: 16px; /* Adjust the font size as needed */\r\n}\r\n\r\n.labelStyle {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* Style for disabled text input boxes */\r\n.disabled-input {\r\n  width: 100%;\r\n  height: 40px;\r\n  padding: 10px;\r\n  margin-bottom: 20px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n  background-color: #f4f4f4; /* Background color for disabled boxes */\r\n}\r\n\r\n.row-container {\r\n  padding: 10px 0; /* Adjust the padding as needed */\r\n}\r\n\r\n.button-group {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n/* Style for individual buttons (optional) */\r\n.button-group button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n/* Style for individual buttons */\r\n.action-button {\r\n  width: 50px !important; /* Adjust the width as desired */\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.action-member-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.marginTop {\r\n  margin-top: 20px !important;\r\n}\r\n\r\n/* Add this CSS to your stylesheet */\r\n.green-border-input {\r\n  border: 2px solid #56a080 !important; /* Green border color */\r\n  background-position: right center !important; /* Position the tick mark on the right-center */\r\n  background-size: 16px !important; /* Adjust the size as needed */\r\n  padding-right: 20px !important; /* Add some padding for the tick mark */\r\n  width: 100%; /* Set a fixed width for all text boxes */\r\n  height: 40px; /* Set a fixed height for all text boxes */\r\n  padding: 10px; /* Adjust the padding as needed */\r\n  margin-bottom: 10px; /* Add spacing between text boxes */\r\n  border-radius: 4px; /* Add your desired border radius */\r\n  font-size: 16px; /* Adjust the font size as needed */\r\n}\r\n.red-border-input {\r\n  border: 2px solid red !important; /* Green border color */\r\n  background-position: right center !important; /* Position the tick mark on the right-center */\r\n  background-size: 16px !important; /* Adjust the size as needed */\r\n  padding-right: 20px !important; /* Add some padding for the tick mark */\r\n  width: 100%; /* Set a fixed width for all text boxes */\r\n  height: 40px; /* Set a fixed height for all text boxes */\r\n  padding: 10px; /* Adjust the padding as needed */\r\n  margin-bottom: 10px; /* Add spacing between text boxes */\r\n  border-radius: 4px; /* Add your desired border radius */\r\n  font-size: 16px; /* Adjust the font size as needed */\r\n}\r\n\r\n.action-limit-width {\r\n  width: 20px !important; /* Adjust the width as desired */\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.insurance button {\r\n  width: 50px !important;\r\n}\r\n\r\n/* TermLifeContent.css */\r\n\r\n/* Style for the DataGrid header */\r\n.data-grid .MuiDataGrid-colCellWrapper {\r\n  background-color: transparent; /* Set the header background color to transparent */\r\n  color: white; /* Set the header text color */\r\n  border-bottom: none; /* Remove the bottom border from the header */\r\n}\r\n\r\n/* Style for the DataGrid rows */\r\n.data-grid .MuiDataGrid-row {\r\n  border-bottom: none; /* Remove the border below each row */\r\n}\r\n\r\n/* Style for the DataGrid selected rows */\r\n.data-grid .Mui-selected {\r\n  background-color: transparent; /* Set the background color for selected rows to transparent */\r\n}\r\n\r\n/* TermLifeContent.css */\r\n\r\n.radio-group-label {\r\n  margin-top: 12px !important; /* Adjust the top margin as needed */\r\n  /* margin-left: 10px !important;  */\r\n}\r\n\r\n.long-text-input {\r\n  width: 100%; /* Adjust the width as needed */\r\n}\r\n\r\n.validation-error {\r\n  color: red;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
